import * as React from "react";
import { NavLink } from 'react-router-dom';
import { LoginLogoutButton, MainNavigation } from "soprasteria-ui-library";
import { SearchPatientForm } from "../SearchPatient/SearchPatientForm";
import { UserCard } from "../UserCard/UserCard";
import { UNLISTED_PATIENTS, SELECT_CLINIC, LISTED_PATIENTS, REFERRAL_SUMMARY, RISK_POT_REPORT_WITH_REGISTERED_PRE_ASSESSMENT, REFERRAL_SEARCH, CHECK_BUDGETS, RISK_POT_REPORT_SEARCH, IMPORTED_XMLS, EMAIL_SETTING, ORTHODONTIC_REFERRAL_SEARCH, ORTHODONTIC_LKGCF_PATIENTS, GENERAL_DENTAL_REFERRAL_SEARCH, ORTHODONTIC_REFERRAL_PROVNINGSKONSULT, INVOICES, UNLISTED_INFANTS, ENDED_LISTINGS, PATIENT_TREATMENT_SEARCH, PREVENTION_PROGRAM_INFANTS, RISK_POT_REPORT_PRE_ASSESSMENT_SEARCH, ORTHODONTIC_LKGCF_PATIENT_EXTENSION_SEARCH, ORTHODONTIC_REFERRAL_ADVANCED_CONSULTATION_NEEDS_FOR_CONSULTATION_DENTAL_GROUP, ORTHODONTIC_REFERRAL_ADVANCED_CONSULTATION_NEEDS_FOR_JOINT_CONSULTATION_GROUP, EMERGENCY_TREATMENT_SEARCH, PATIENTS_REFRAINING_FREE_DENTAL_CARE, ADDITIONAL_ASSIGNMENTS } from "../../utils/RouteConstants";
import { useAuth, AuthConsumer } from "../../App";
import { AdditionalAssignmentApi } from "../../api/AdditionalAssignmentApi";
import { AreaResponsibilityApi } from "../../api/AreaResponsibilityApi";
import { ALLMÄNTANDVÅRDBAS, SPECIALISTTANDVÅRDBAS, BEDÖMNINGSTANDLÄKARE, SAMRÅDSGRUPP, URVALSTANDLÄKAREBAS, TANDREGLERINGBAS, KÄKORTOPEDIBAS, ALLMÄNTANDVÅRDAKUTTANDVÅRDFAKTURERARE, TANDREGLERINGFAKTURERARE, ALLMÄNTANDVÅRDINTERCEPTIVAPPARATURFAKTURERARE, ALLMÄNTANDVÅRDFAKTURERARERISKPOTT, SPECIALISTTANDVÅRDFAKTURERARE, KÄKORTOPEDIFAKTURERARE, URVALSTANDLÄKAREFAKTURERARE, VÅRDANSVARIG, LIBRETTOADMIN } from "../../utils/RoleConstants"
import { UserContext, isInRole } from "../../contexts/UserContext";
import { LIB_WEB_BASE_URL, CHANGE_APP_URL } from "../../utils/Config";
import "./Navbar.scss";
import { IGotAreaResponsibilityContract } from "../../models/IGotAreaResponsibilityContract";

export const Navbar: React.FunctionComponent<{}> = () => {
    const auth = useAuth();
    const userInfo = React.useContext(UserContext);
    const additionalAssignmentApi = new AdditionalAssignmentApi(auth);
    const areaResponsibilityApi = new AreaResponsibilityApi(auth);
    const [hasAdditionalAssignments, setHasAdditionalAssignments] = React.useState<boolean>(false);
    const [hasPreventionProgramContract, setHasPreventionProgramContract] = React.useState<boolean>(false);
    const hasRoleAllmantandvard = isInRole(ALLMÄNTANDVÅRDBAS, userInfo.roles);
    const hasRoleSystemAdmin = isInRole(LIBRETTOADMIN, userInfo.roles);
    const hasRoleSpecialisttandvard = isInRole(SPECIALISTTANDVÅRDBAS, userInfo.roles);
    const hasRoleBedomningsTandlakare = isInRole(BEDÖMNINGSTANDLÄKARE, userInfo.roles);
    const hasRoleKonsulttandläkare = isInRole(URVALSTANDLÄKAREBAS, userInfo.roles);
    const hasRoleOrtodontist = isInRole(TANDREGLERINGBAS, userInfo.roles);
    const hasRoleLkgCf = isInRole(KÄKORTOPEDIBAS, userInfo.roles);
    const hasRoleAllmäntandvårdAkuttandvårdFakturerare = isInRole(ALLMÄNTANDVÅRDAKUTTANDVÅRDFAKTURERARE, userInfo.roles);
    const hasRoleOrtodontisttandvårdFakturerare = isInRole(TANDREGLERINGFAKTURERARE, userInfo.roles);
    const hasRoleAllmäntandvårdInterceptivcheckFakturerare = isInRole(ALLMÄNTANDVÅRDINTERCEPTIVAPPARATURFAKTURERARE, userInfo.roles);
    const hasRoleAllmäntandvårdFHBFakturerare = isInRole(ALLMÄNTANDVÅRDFAKTURERARERISKPOTT, userInfo.roles);
    const hasRoleSpecialisttandvårdFakturerare = isInRole(SPECIALISTTANDVÅRDFAKTURERARE, userInfo.roles);
    const hasRoleLkgCfFakturerare = isInRole(KÄKORTOPEDIFAKTURERARE, userInfo.roles);
    const hasRoleProvningskonsult = isInRole(SAMRÅDSGRUPP, userInfo.roles);
    const hasRoleKonsultRemissFakturerare = isInRole(URVALSTANDLÄKAREFAKTURERARE, userInfo.roles);
    const hasRoleParaply = isInRole(VÅRDANSVARIG, userInfo.roles);

    React.useEffect(() => {
        if (hasRoleAllmantandvard) {
            additionalAssignmentApi.hasAdditionalAssignments((hasAdditionalAssignmentsResponse: boolean) => {
                setHasAdditionalAssignments(hasAdditionalAssignmentsResponse);
            });
            areaResponsibilityApi.gotContract((hasContractResponse: IGotAreaResponsibilityContract) => {
                setHasPreventionProgramContract(hasContractResponse.hasActivePreventionProgramContract);
            });
        } else {
            setHasAdditionalAssignments(false);
            setHasPreventionProgramContract(false);
        }
    }, [userInfo.roles])

    const renderAreaResponsibilityMenu = () => {
        return (
            <>
                {
                    hasAdditionalAssignments || hasPreventionProgramContract || hasRoleSystemAdmin ?
                        <ul className="navbar-nav">
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Områdesansvar
                                </a>
                                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    {
                                        hasAdditionalAssignments || hasRoleSystemAdmin ?
                                            <>
                                                <NavLink to={`/${UNLISTED_PATIENTS}`} className="dropdown-item" >Visa olistade patienter</NavLink>
                                                <NavLink to={`/${ADDITIONAL_ASSIGNMENTS}`} className="dropdown-item" >Visa tilläggsuppdrag</NavLink>
                                            </> : null
                                    }                                    
                                    {
                                        hasPreventionProgramContract ?
                                            <NavLink to={`/${PREVENTION_PROGRAM_INFANTS}`} className="dropdown-item" >Visa kariespreventionsprogram 0-2 år</NavLink>
                                            : null
                                    }
                                </div>
                            </li>
                        </ul>
                        : null
                }
            </>
        )
    }

    const renderReferralMenu = () => {
        return (
            <>
                {
                    hasRoleSpecialisttandvard || hasRoleBedomningsTandlakare || hasRoleAllmantandvard || hasRoleLkgCf ||
                        hasRoleSystemAdmin || hasRoleOrtodontist || hasRoleKonsulttandläkare ?
                        <ul className="navbar-nav">
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Remisser
                                </a>
                                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    {hasRoleBedomningsTandlakare ?
                                        <NavLink to={`/${REFERRAL_SUMMARY}/${1}`} className="dropdown-item" >Granska specialistremisser</NavLink>
                                        : null
                                    }
                                    {hasRoleAllmantandvard || hasRoleSystemAdmin || hasRoleSpecialisttandvard || hasRoleLkgCf || hasRoleOrtodontist ?
                                        <NavLink to={`/${REFERRAL_SEARCH}`} className="dropdown-item" >Sök specialistremiss</NavLink>
                                        : null
                                    }
                                    {hasRoleKonsulttandläkare || hasRoleAllmantandvard || hasRoleSystemAdmin || hasRoleOrtodontist ?
                                        <NavLink to={`/${ORTHODONTIC_REFERRAL_SEARCH}`} className="dropdown-item" >Sök ortodontiremiss</NavLink>
                                        : null
                                    }
                                    {hasRoleOrtodontist || hasRoleAllmantandvard || hasRoleSystemAdmin ?
                                        <NavLink to={`/${GENERAL_DENTAL_REFERRAL_SEARCH}`} className="dropdown-item" >Sök allmäntandvårdsremiss</NavLink>
                                        : null
                                    }
                                </div>
                            </li>
                        </ul>
                        : null
                }
            </>
        )
    }

    const renderRiskPotReportMenu = () => {
        return (
            <>
                {
                    hasRoleSystemAdmin || hasRoleBedomningsTandlakare || (userInfo.isRiskPotCareProvider && hasRoleAllmantandvard) ?
                        <ul className="navbar-nav">
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Riskpott
                                </a>
                                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    {
                                        hasRoleBedomningsTandlakare ?
                                            <NavLink to={`/${RISK_POT_REPORT_WITH_REGISTERED_PRE_ASSESSMENT}`} className="dropdown-item" >Inkomna förhandsbedömningar</NavLink>
                                            : null
                                    }
                                    {
                                        hasRoleSystemAdmin || hasRoleBedomningsTandlakare || (userInfo.isRiskPotCareProvider && hasRoleAllmantandvard)
                                            ?
                                            <NavLink to={`/${RISK_POT_REPORT_SEARCH}`} className="dropdown-item" >Sök riskpottsärende</NavLink>
                                            : null
                                    }
                                </div>
                            </li>
                        </ul>
                        : null
                }
            </>
        )
    }

    const renderSelectionAreaMenu = () => {
        return (
            <>
                {
                    hasRoleKonsulttandläkare ?
                        <ul className="navbar-nav">
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Urvalsområden
                                </a>
                                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <NavLink to={`/${CHECK_BUDGETS}`} className="dropdown-item" >Vårderbjudanden att besluta</NavLink>
                                </div>
                            </li>
                        </ul>
                        : null
                }
            </>
        )
    }

    const renderImportedXmlsMenu = () => {
        return (
            <>
                {
                    hasRoleAllmantandvard || hasRoleSpecialisttandvard || hasRoleSystemAdmin ?
                        <ul className="navbar-nav">
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Filinläsning
                                </a>
                                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <NavLink to={`/${IMPORTED_XMLS}`} className="dropdown-item" >Sök importfiler</NavLink>
                                </div>
                            </li>
                        </ul>
                        : null
                }
            </>
        )
    }

    const renderPatientTreatmentMenu = () => {
        return (
            <>
                {
                    hasRoleAllmantandvard || hasRoleSpecialisttandvard || hasRoleOrtodontist || hasRoleSystemAdmin || hasRoleLkgCf ?
                        <ul className="navbar-nav">
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Åtgärdskoder
                                </a>
                                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <NavLink to={`/${PATIENT_TREATMENT_SEARCH}`} className="dropdown-item" >Sök åtgärdskoder</NavLink>
                                </div>
                            </li>
                        </ul>
                        : null
                }
            </>
        )
    }

    const renderEmergencyTreatmentMenu = () => {
        return (
            <>
                {
                    hasRoleAllmantandvard || hasRoleSystemAdmin ?
                        <ul className="navbar-nav">
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Akuträkning
                                </a>
                                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <NavLink to={`/${EMERGENCY_TREATMENT_SEARCH}`} className="dropdown-item" >Sök akuträkning</NavLink>
                                </div>
                            </li>
                        </ul>
                        : null
                }
            </>
        )
    }

    return (
        <MainNavigation
            imagePath={`${LIB_WEB_BASE_URL}/images/sll_logo.png`}
            rightContent=
            {
                <>
                    <UserCard name={userInfo ? userInfo.username : ""}
                        careProviderName={userInfo?.clinicName ? userInfo.clinicName : userInfo.organisationName}
                        organisationNumber={userInfo ? userInfo.organisationNumber : ""}
                        clinicNumber={userInfo ? userInfo.clinicNumber : ""}
                        roles={userInfo.roles} />
                    <div className="user-buttons text-right">
                        <NavLink to={`/${SELECT_CLINIC}`} className="nav-link" >Välj mottagning</NavLink>
                        <span>|</span>
                        <a href={`${CHANGE_APP_URL && CHANGE_APP_URL !== "" ? CHANGE_APP_URL : "#"}`} className="nav-link">Byt IT-System</a>
                        <span>|</span>
                        <LoginLogoutButton AuthConsumer={AuthConsumer} />
                    </div>
                </>
            }
            informationTopRight="Dina aktiviteter i systemet loggas och kan komma att kontrolleras i efterhand"
        >
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>

            <ul className="navbar-nav">
                <li className="nav-item">
                    <NavLink to={``} className="nav-link" >Hem</NavLink>
                </li>
            </ul>
            <div className="collapse navbar-collapse" id="navbarNavDropdown">
                {
                    renderAreaResponsibilityMenu()
                }
                {
                    renderSelectionAreaMenu()
                }
                <ul className="navbar-nav">
                    {hasRoleAllmantandvard || hasRoleSystemAdmin ?
                        <ul className="navbar-nav">
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Listade patienter
                                </a>
                                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <NavLink to={`/${LISTED_PATIENTS}`} className="dropdown-item" >Visa listade patienter</NavLink>
                                    <NavLink to={`/${ENDED_LISTINGS}`} className="dropdown-item" >Visa avlistade patienter</NavLink>
                                    {
                                        hasRoleSystemAdmin ?
                                            <NavLink to={`/${PATIENTS_REFRAINING_FREE_DENTAL_CARE}`} className="dropdown-item" >Visa patienter som avstår avgiftsfri tandvård</NavLink>
                                            : null
                                    }
                                </div>
                            </li>
                        </ul>
                        : null
                    }
                </ul>
                <ul className="navbar-nav">
                    {hasRoleLkgCf || hasRoleBedomningsTandlakare || hasRoleSystemAdmin ?
                        <ul className="navbar-nav">
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Käkortopedi
                                </a>
                                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    {
                                        hasRoleLkgCf || hasRoleSystemAdmin ?
                                            <NavLink to={`/${ORTHODONTIC_LKGCF_PATIENTS}`} className="dropdown-item" >Visa registrerade patienter</NavLink>
                                            : null
                                    }
                                    <NavLink to={`/${ORTHODONTIC_LKGCF_PATIENT_EXTENSION_SEARCH}`} className="dropdown-item" >Sök ansökningar om förlängning av LKG/CF</NavLink>
                                </div>
                            </li>
                        </ul>
                        : null
                    }
                </ul>
                {
                    renderEmergencyTreatmentMenu()
                }
                {
                    renderReferralMenu()
                }
                {
                    renderRiskPotReportMenu()
                }
               
                <ul className="navbar-nav">
                    {
                        hasRoleKonsulttandläkare || hasRoleProvningskonsult || hasRoleSystemAdmin ?
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Ortodonti
                                </a>
                                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    {
                                        hasRoleProvningskonsult || hasRoleSystemAdmin ?
                                            <NavLink to={`/${ORTHODONTIC_REFERRAL_PROVNINGSKONSULT}`} className="dropdown-item" >Ortodontiremisser för bedömning</NavLink>
                                            : null
                                    }
                                    {
                                        hasRoleKonsulttandläkare || hasRoleSystemAdmin ?
                                            <NavLink to={`/${ORTHODONTIC_REFERRAL_ADVANCED_CONSULTATION_NEEDS_FOR_CONSULTATION_DENTAL_GROUP}`} className="dropdown-item" >Urvalstandläkargruppen</NavLink>
                                            : null
                                    }
                                    {
                                        hasRoleProvningskonsult || hasRoleSystemAdmin ?
                                            <NavLink to={`/${ORTHODONTIC_REFERRAL_ADVANCED_CONSULTATION_NEEDS_FOR_JOINT_CONSULTATION_GROUP}`} className="dropdown-item" >Samrådsgruppen</NavLink>
                                            : null
                                    }
                                </div>
                            </li>
                            : null
                    }
                    </ul>
                

                <ul className="navbar-nav">
                    {
                        hasRoleAllmäntandvårdAkuttandvårdFakturerare || hasRoleOrtodontisttandvårdFakturerare || hasRoleAllmäntandvårdInterceptivcheckFakturerare || hasRoleAllmäntandvårdFHBFakturerare || hasRoleSpecialisttandvårdFakturerare || hasRoleLkgCfFakturerare || hasRoleSystemAdmin || hasRoleKonsultRemissFakturerare ?
                            <ul className="navbar-nav">
                                <li className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Fakturering
                                    </a>
                                    <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                        <NavLink to={`/${INVOICES}`} className="dropdown-item" >Sök och hantera fakturor</NavLink>
                                    </div>
                                </li>
                            </ul>
                            : null
                    }
                </ul>
                {
                    renderImportedXmlsMenu()
                }
                {
                    renderPatientTreatmentMenu()
                }
                {!hasRoleSystemAdmin ?
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <NavLink to={`/${EMAIL_SETTING}`} className="nav-link">E-postinställningar</NavLink>
                        </li>
                    </ul>
                    : null
                }
                <ul className="navbar-nav ml-auto">
                    {hasRoleAllmantandvard || hasRoleSystemAdmin || hasRoleSpecialisttandvard || hasRoleKonsulttandläkare || hasRoleOrtodontist || hasRoleLkgCf ?
                        <li className="nav-item">
                            <SearchPatientForm />
                        </li>
                        : null}
                </ul>
            </div>
        </MainNavigation>
    );
}

